import React, {useEffect} from 'react';

import MainLayout from "../layout/MainLayout";
import SimpleCardContainer from "../ui/SimpleCardContainer";
import TableEditable from "../ui/TableEditable";
import {useApi} from "../../providers/ApiProvider";
import UsersModel from "../../models/UsersModel";
import {useBreadcrumbs} from "../../providers/BreadcrumbsProvider";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../providers/TranslationProvider";
import BusinessesPostMedia from "../businesses/posts/BusinessesPostMedia";
import BusinessesPostAddStandard from "../businesses/posts/BusinessesPostAddStandard";
import BusinessesPostAddEvent from "../businesses/posts/BusinessesPostAddEvent";
import BusinessesPostAddOffer from "../businesses/posts/BusinessesPostAddOffer";
import BusinessesPostAddPublish from "../businesses/posts/BusinessesPostAddPublish";
import {useAuth} from "../../providers/AuthProvider";
import {useParams} from "react-router-dom";
import accountTypesModel from "modernize-essentials/libs/quill/dist/quill.min";
import AccountTypesModel from "../../models/AccountTypesModel";
import FormCheckbox from "../layout/ui/FormCheckbox";

function UserEdit(props) {
    const params = useParams();
    const authContext = useAuth();
    const userData = authContext.user;
    const {language} = useMyTranslation();
    const breadcrumbs = useBreadcrumbs();
    const apiContext = useApi();
    const usersModel = new UsersModel(apiContext.api);
    const accountTypesModel = new AccountTypesModel(apiContext.api);

    const { t} = useTranslation();
    const [billingPlan, setBillingPlan] = React.useState('free');
    const [parameters, setParameters] = React.useState({});
    const [name, setName] = React.useState('');
    const [types, setTypes] = React.useState({});
    const [loading, setLoading] = React.useState(true);


    useEffect(() => {
        setLoading(true);
        breadcrumbs.update({
            title: t('Edit user information'),
            breadcrumbs: [
                {label: t('Users'), url: '/users'},
                {label: t('Edit user information')}
            ]
        });

        document.title = t('Edit user information')+' | LocalBoost';

        usersModel.view(params.userId).then((response) => {
            if (response !== false) {
                setName(response.name);
                setBillingPlan(response.type);
                setParameters(response.parameters);
            }

            return accountTypesModel.list().then((response) => {
                if (response !== false) {
                    let newTypes = {};
                    response.map((type) => {
                        newTypes[type.id] = type.name;
                    });
                    setTypes(newTypes);
                }
            });
        }).finally(() => {
            setLoading(false);
        });


    }, [language]);


    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        usersModel.update(params.userId, {
            'type': billingPlan,
            'name': name,
            'parameters': parameters
        }).then((response) => {
            if (response !== false) {
                window.location.href = '/users';
            }
        }).finally(() => {
            setLoading(false);
        });
    }


    const onImpersonate = (e) => {
        e.preventDefault();

        usersModel.impersonate(params.userId).then((response) => {
            if (response !== false) {
                const formattedResponse = {
                    access_token: response
                }
                let user = usersModel.processAuthResponse(formattedResponse);
                if (user) {
                    authContext.logout();
                    authContext.login(user);
                    window.location.href = '/';
                }
            }
        });
    }


    return (
        <SimpleCardContainer title={t('Edit user information')} loading={loading}>
            <form className={'py-2'}>
                <div className={'row'}>
                    <div className={'col-md-6'}>
                        <div className={'form-group'}>
                            <label className="form-label fw-semibold mb-2">{t('Full name')}</label>

                            <input id={'cd-name'} className={'form-control'} value={name} onChange={(e) => {
                                setName(e.target.value)
                            }}/>
                        </div>

                        <div className={'form-group mt-3'}>
                            <label className="form-label fw-semibold mb-2">{t('Current billing plan')}</label>

                            <select id={'cd-button'} className={'form-control form-select'} value={billingPlan} onChange={(e) => {
                                setBillingPlan(e.target.value)
                            }}>
                                {Object.keys(types).map((key) => {
                                    return <option value={key} key={key}>{types[key]}</option>
                                })}
                            </select>
                        </div>

                        <FormCheckbox
                            groupClassName="form-group mt-3 form-check w-100"
                            label={t('All Reviews page available')}
                            onChange={(value) => setParameters({...parameters, all_reviews_available: value})}
                            value={parameters && parameters.all_reviews_available ? parameters.all_reviews_available : false}
                        />

                        <FormCheckbox
                            groupClassName="form-group mt-3 form-check w-100"
                            label={t('Competitors available')}
                            onChange={(value) => setParameters({...parameters, competitors_available: value})}
                            value={parameters && parameters.competitors_available ? parameters.competitors_available : false}
                        />

                        <div className={'form-group mt-3'}>
                            <button className="btn btn-primary" onClick={onSubmit}>{t('Save changes')}</button>
                        </div>
                    </div>
                    <div className={'col-md-6'}>
                        <div className="bordered-tip pb-4 pt-4">
                            <div className="alert alert-warning fs-2">
                                <strong>{t('Warning!')}</strong><br/>
                                {t('You can operate on user\'s behalf now.')}

                                <button className={'btn btn-danger d-flex align-items-center mt-3'} onClick={onImpersonate}>
                                    <i className={'ti ti-status-change fs-4 me-2'}></i>
                                    {t('Impersonate user')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </SimpleCardContainer>
    );
}

export default UserEdit;
